import { Lesson } from "@jelly/lesson";
import principle01 from "../lesson-28/layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";

const lesson: Lesson = {
  id: "6372a17f-dd3d-47c5-b526-fd5ff3942ea4",
  publicId: "28",
  name: "Uncertainties of simulations",
  difficulty: 2,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, task01, task02],
};

export default lesson;
